import EmojiPicker, { Theme } from "emoji-picker-react";
import { useTranslation } from "react-i18next";
import useThemeStore from "../store/useThemeStore";
import { getStoredLangCode } from "../utils/language";

const ThemedEmojiPicker = (props) => {
  const isDark = useThemeStore((state) => state.isDark);
  const { t } = useTranslation();
  const lang = getStoredLangCode();
  const isRtl = lang === "ar";

  const {
    width,
    height,
    searchPlaceHolder,
    previewConfig,
    ...rest
  } = props;

  return (
    <div
      className={`themed-emoji-picker-wrap${isRtl ? " themed-emoji-picker-rtl" : ""}`}
      dir={isRtl ? "rtl" : "ltr"}
    >
      <EmojiPicker
        {...rest}
        theme={isDark ? Theme.DARK : Theme.LIGHT}
        width={width ?? (isRtl ? 320 : 350)}
        height={height ?? 400}
        searchPlaceHolder={
          searchPlaceHolder ||
          t("SearchJob.Search", { defaultValue: "Search..." })
        }
        previewConfig={{
          showPreview: true,
          defaultCaption: t("Notifications.WhatsYourMood", {
            defaultValue: "What's your mood?",
          }),
          ...(previewConfig || {}),
        }}
      />
    </div>
  );
};

export default ThemedEmojiPicker;
